import { useLocation } from 'react-router-dom';

export const useAccessTokenFromHash = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.hash.substring(1));

    const token = params.get('access_token');
    const expiresIn = params.get('expires_in');

    return { token, expiresIn };
};
